"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Caption = void 0;
var react_1 = __importDefault(require("react"));
var RenderTokensHostContext_1 = require("../RenderTokensHost/RenderTokensHostContext");
var GenericTextComponent_1 = require("../../Public/Widgets/GenericText/GenericTextComponent");
var Caption = function (_a) {
    var childTokens = _a.childTokens;
    var RenderTokensHost = (0, RenderTokensHostContext_1.useRenderTokensHostContext)().RenderTokensHost;
    var renderEmptyBreak = (0, GenericTextComponent_1.childTokensAreEmpty)(childTokens);
    return (react_1.default.createElement("p", { className: "p-widget__spacing-shim project-block__block-element" }, renderEmptyBreak ? react_1.default.createElement("br", null) : react_1.default.createElement(RenderTokensHost, { tokens: childTokens })));
};
exports.Caption = Caption;
